module.exports = __webpack_public_path__ + "img/circle-x.6c0119f7.svg";